import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { useDrawingArea } from '@mui/x-charts/hooks';
import { styled } from '@mui/material/styles';
import jwt_decode from 'jwt-decode';

const data = [
  { value: 5, label: 'Orphan' },
  { value: 200, label: 'Quarantine' },
  { value: 100, label: 'Waiting to ship' },
];

const size = {
  width: 400,
  height: 200,
};

const StyledText = styled('text')(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fontSize: 20,
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

export default function PieChartWithCenterLabel() {
  return (
    <PieChart series={[{ data, innerRadius: 80 }]} {...size}>
      <PieCenterLabel>{(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).location : 'Orlando' )}</PieCenterLabel>
    </PieChart>
  );
}
